export default __webpack_public_path__ + "static/media/petfriendly.4ef10022.png";